export const TOASTS_WRAPPER_ELEMENT_ID = 'toasts-wrapper'
